import React, { useState, useEffect } from "react";
import "./Contact.css";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000,
      easing: "ease-in-out-cubic",
      once: true,
      offset: 100,
    });
  }, []);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit form
  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name || !formData.email || !formData.message) {
    setStatus("Please fill in all required fields.");
    return;
  }

  setLoading(true);

  try {
    const res = await fetch("https://formspree.io/f/xlgrnyyj", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(formData),
    });

    if (res.ok) {
      setStatus("Message sent successfully!");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } else {
      setStatus("Failed to send message.");
    }
  } catch (error) {
    setStatus("Network error. Try again later.");
  } finally {
    setLoading(false);
    setTimeout(() => setStatus(""), 4000);
  }
};


  return (
    <div className="contact-page">
      {/* Breadcrumb */}
      <div className="breadcrumb" data-aos="fade-right">
        Home <span>›</span> Contact Us
      </div>

      <h2 className="contact-title" data-aos="fade-up" data-aos-delay="100">
        Contact Us
      </h2>

      <div className="contact-container">
        {/* LEFT SECTION */}
        <div className="contact-left" data-aos="fade-right" data-aos-delay="200">
          <h3>OurCountry OurPeople Foundation, Chennai</h3>
          <p className="addr">
            No.4/186, P No 24, Venkateshwara Avenue Mathana Puran,
            Mudichur, Chennai – 600048.
          </p>

          <h4>Phone numbers (24 Hours Available)</h4>
          <p className="phone">044-45062816</p>
          <p className="phone">+91-9840693733</p>
          <p className="phone">+91-9384149383</p>

          <h4>E-mail address</h4>
          <p className="email">namnadunammakkall@gmail.com</p>
        </div>

        {/* RIGHT FORM */}
        <form
          className="contact-form"
          onSubmit={handleSubmit}
          data-aos="fade-left"
          data-aos-delay="400"
        >
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
          />

          <input
            type="text"
            name="subject"
            placeholder="Subject (optional)"
            value={formData.subject}
            onChange={handleChange}
          />

          <textarea
            name="message"
            placeholder="Message"
            value={formData.message}
            onChange={handleChange}
          ></textarea>

          <button type="submit" className="send-btn" disabled={loading}>
            {loading ? "Sending..." : "SEND MESSAGE"}
          </button>

          {status && <p className="note">{status}</p>}
        </form>
      </div>

      {/* GOOGLE MAP */}
      <div className="map-wrapper" data-aos="zoom-in" data-aos-delay="500">
        <iframe
          title="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3895.53978783204!2d80.0761386!3d12.91644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52f573af758183%3A0x4f5d426982f02673!2sOur%20country%20our%20people%20foundation!5e0!3m2!1sen!2sin!4v1234567890"
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
}
